export namespace ReleasePlatformConstants {
  export const RELEASE_PLATFORM_CODE_IOS: string = 'IOS';
  export const RELEASE_PLATFORM_CODE_ANDROID: string = 'ANDROID';
  export const RELEASE_PLATFORM_CODE_WEB: string = 'WEB';
}
